import { render, staticRenderFns } from "./HorasTipoServicio.vue?vue&type=template&id=373c23ce&"
import script from "./HorasTipoServicio.vue?vue&type=script&lang=js&"
export * from "./HorasTipoServicio.vue?vue&type=script&lang=js&"
import style0 from "./HorasTipoServicio.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports